module.exports = __webpack_public_path__ + "static/media/binomialCrit.d287956d.png";